var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.7019 2.7019C6.3114 2.09241 7.13805 1.75 8 1.75C8.86195 1.75 9.6886 2.09241 10.2981 2.7019C10.9076 3.3114 11.25 4.13805 11.25 5V8.25H4.75V5C4.75 4.13805 5.09241 3.3114 5.7019 2.7019ZM3.25 8.25V5C3.25 3.74022 3.75044 2.53204 4.64124 1.64124C5.53204 0.750445 6.74022 0.25 8 0.25C9.25978 0.25 10.468 0.750445 11.3588 1.64124C12.2496 2.53204 12.75 3.74022 12.75 5V8.25H13C14.5188 8.25 15.75 9.48122 15.75 11V17C15.75 18.5188 14.5188 19.75 13 19.75H3C1.48122 19.75 0.25 18.5188 0.25 17V11C0.25 9.48122 1.48122 8.25 3 8.25H3.25ZM12 9.75H13C13.6904 9.75 14.25 10.3096 14.25 11V17C14.25 17.6904 13.6904 18.25 13 18.25H3C2.30964 18.25 1.75 17.6904 1.75 17V11C1.75 10.3096 2.30964 9.75 3 9.75H4H12ZM8 15C8.55228 15 9 14.5523 9 14C9 13.4477 8.55228 13 8 13C7.44772 13 7 13.4477 7 14C7 14.5523 7.44772 15 8 15Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/locked.cca8a37475ca04e993e186409202672d.svg";
export { ForwardRef as ReactComponent };